import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import { toast } from "react-hot-toast";

export const usePostRedefinirSenha = (setError: Function) => {
  const onSuccess = (response: any) => {
    if (response?.data !== "") {
      setError("email", {
        type: "emailNotFound",
        message: "Não existe cadastro para o email digitado",
      });
    } else {
      toast.success("E-mail enviado com sucesso.");
    }
  };

  return usePost<object>({
    url: api.login.postRedefinirSenha,
    onSuccess,
  });
};
